/* eslint-disable react/jsx-key */
import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { Redirect } from '@americanexpress/one-app-router';

import onEnterBusinessBankingAccounts from './utils/onEnterBusinessBankingAccounts';
import onEnterBusinessCheckingDocumentUpload from './utils/onEnterBusinessCheckingDocumentUpload';

import QualtricsScript from './components/QualtricsScript';
import DynatraceScript from './components/DynatraceScript';
import ErrorPageComponent from './components/ErrorPage';
import { Dls6Wrapper, Dls7Wrapper } from './components/DlsWrapper';
import redirectToAccountDetails from './utils/redirectToAccountDetails';
import onEnterSetSelectedProduct from './utils/onEnterSetSelectedProduct';
import redirectToProductHome from './utils/redirectToProductHome';

export const childRoutes = (store) => [
  <ModuleRoute component={Dls7Wrapper}>
    <ModuleRoute path="error" component={ErrorPageComponent} />
  </ModuleRoute>,
  <Redirect from="checkbook-order" to="/en-us/banking/order-checkbook" />,
  <ModuleRoute component={Dls6Wrapper}>
    <ModuleRoute
      path="registration"
      moduleName="banking-business-checking-account-registration"
    />
  </ModuleRoute>,
  <ModuleRoute component={Dls6Wrapper}>
    <ModuleRoute
      path="onboarding/additional-user"
      moduleName="blueprint-additional-user-onboarding"
    />
  </ModuleRoute>,
  <ModuleRoute component={Dls6Wrapper}>
    <ModuleRoute path="static" moduleName="banking-business-checking-static" />
  </ModuleRoute>,
  <ModuleRoute onEnter={onEnterBusinessCheckingDocumentUpload(store)}>
    <ModuleRoute component={Dls6Wrapper}>
      <ModuleRoute
        path="document-upload"
        moduleName="banking-business-checking-document-upload"
      />
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute onEnter={onEnterBusinessBankingAccounts(store)}>
    <ModuleRoute path="accounts" onEnter={redirectToProductHome(store)} />
    <ModuleRoute onEnter={onEnterSetSelectedProduct(store)}>
      <ModuleRoute component={DynatraceScript}>
        <ModuleRoute component={QualtricsScript}>
          <ModuleRoute path="home" onEnter={redirectToAccountDetails(store)} />
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute
              path="accounts/manage/checkbook-order"
              moduleName="banking-business-checking-checkbook-order"
            />
            <ModuleRoute moduleName="banking-business-checking-wrapper">
              <ModuleRoute
                path="accounts/manage/debit/card-replacement"
                moduleName="banking-debit-card-replacement"
              />
              <ModuleRoute
                path="support"
                moduleName="banking-business-checking-support"
              />
              <ModuleRoute moduleName="vertical-navigation-menu">
                <ModuleRoute
                  path="zelle"
                  moduleName="banking-business-checking-zelle"
                />
                <ModuleRoute
                  path="accounts/open-new-account"
                  moduleName="banking-business-checking-new-account"
                />
                <ModuleRoute
                  path="accounts/manage"
                  moduleName="banking-business-checking-account-management"
                />
                <ModuleRoute path="accounts/manage">
                  <ModuleRoute
                    path="external-accounts"
                    moduleName="banking-business-checking-manage-external-accounts"
                  />
                  <ModuleRoute
                    path="debit"
                    moduleName="banking-debit-card-management"
                  />
                  <ModuleRoute
                    path="users"
                    moduleName="banking-business-checking-manage-users"
                  />
                  <ModuleRoute
                    path="profile"
                    moduleName="banking-business-checking-manage-profile"
                  />
                </ModuleRoute>
                <ModuleRoute
                  path="accounts/:accountIdentifier"
                  moduleName="banking-business-account-details"
                />
                <ModuleRoute
                  path="payments/manage"
                  moduleName="banking-business-checking-payment-management"
                />
                <ModuleRoute
                  path="transfers/manage"
                  moduleName="banking-business-checking-payment-management"
                />
              </ModuleRoute>
              <ModuleRoute
                path="restricted"
                moduleName="banking-business-checking-account-restrictions"
              />
              <ModuleRoute path="accounts/manage">
                <ModuleRoute path="external-accounts">
                  <ModuleRoute
                    path="link"
                    moduleName="banking-business-checking-link-external-account"
                  />
                  <ModuleRoute path="link">
                    <ModuleRoute
                      path="log-in"
                      moduleName="banking-business-checking-external-account-log-in"
                    />
                    <ModuleRoute
                      path="suggested"
                      moduleName="banking-business-checking-bank-on-file"
                    />
                    <ModuleRoute
                      path="ownership"
                      moduleName="banking-business-checking-external-account-ownership"
                    />
                    <ModuleRoute
                      path="deposit"
                      moduleName="banking-business-checking-micro-deposits"
                    />
                  </ModuleRoute>
                </ModuleRoute>
              </ModuleRoute>
              <ModuleRoute
                path="payments/manage/scheduled"
                moduleName="banking-business-checking-manage-scheduled-payment"
              />
              <ModuleRoute
                path="transfers/manage/scheduled"
                moduleName="banking-business-checking-manage-scheduled-payment"
              />
              <ModuleRoute
                path="payments/manage/create-payee"
                moduleName="banking-business-checking-create-payee"
              />
              <ModuleRoute
                path="payments/manage-payee"
                moduleName="banking-business-checking-manage-payee"
              />
              <ModuleRoute
                path="payments"
                moduleName="banking-business-checking-payment"
              />
              <ModuleRoute
                path="zelle"
                moduleName="banking-business-checking-zelle"
              />
              <ModuleRoute
                path="transfer"
                moduleName="banking-business-checking-transfer"
              />
              <ModuleRoute
                path="access-not-allowed"
                moduleName="banking-business-checking-access-not-allowed"
              />
              <ModuleRoute
                path="payroll/manage-employees"
                moduleName="banking-business-payroll-manage-employees"
              />
              <ModuleRoute
                path="payroll"
                moduleName="banking-business-payroll-run"
              />
              <ModuleRoute
                path="payroll/enroll"
                moduleName="banking-business-payroll-enrollment"
              />
            </ModuleRoute>
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
  </ModuleRoute>,
];
